var rows = document.getElementById('calc')
var rowCount = 1
var resultField = document.getElementById('result')
addNewRow()

function addNewRow() {
    console.log('adding row')

    var newRow = document.createElement('tr')
        newRow.innerHTML = `
        <td><input id=fach${rowCount} onchange="updateFields()" type="number" placeholder="Fach ${rowCount}"></td>
        <td><input class="grade" onchange="updateFields()" type="number" placeholder="Note"></td>
        <td><input class="weight" id="gewichtung${rowCount}" onchange="updateFields()" type="number" placeholder="Gewichtung"><td></td>                
        `
    rows.appendChild(newRow)
    rowCount +=1
}

function updateFields() {
    console.log(rows)

    var grades = document.getElementsByClassName('grade')
    var gradesArray = Array.from(grades)
    var gradeValues = gradesArray.map(x => x.value)
    console.log({gradeValues})
    
    var weights = document.getElementsByClassName('weight')
    var weightsValues = Array.from(weights).map(x => x.value)
    console.log({weightsValues})
    var gradesWithWeight = []
    var weightsSum = 0

    i = 0
    while (i < weightsValues.length) {
        var grade = gradeValues[i]
        var weight = weightsValues[i]
        console.log('multiply', grade, "with", weight)
        var res = Number(grade)*Number(weight)
        console.log(res, 'res')
        console.log(grade, weight, res)
        gradesWithWeight.push(res)
        weightsSum += Number(weight)
        i += 1
    }
    
    sum = 0
    gradesWithWeight.forEach(element => {
        console.log({gradesWithWeight})
        sum += element
    });

    console.log(sum, 'sum')
    var result = sum / weightsSum
    result = Math.round(result*10)/10
    
    if (!isNaN(result)) {
        if (result == 1) {
            result = '1.0'
        }
        resultField.placeholder = `Dein Notendurchschnitt: ${result}`
    }
  

    

}